import React from "react";

import { DriversAmountCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function driversAmount({ width, onResize }: Column.Options) {
	return base(ColumnId.DriversAmount, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default driversAmount;
